// ============================================================================
// USE FULLSCREEN HOOK
// Browser Fullscreen API + Electron IPC desteği
// ============================================================================
import { useState, useCallback, useEffect } from 'react';

interface UseFullscreenReturn {
  isFullscreen: boolean;
  toggleFullscreen: () => void;
}

export const useFullscreen = (): UseFullscreenReturn => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = useCallback(() => {
    const electronAPI = (window as any).electronAPI;
    if (electronAPI?.send) {
      electronAPI.send('toggle-fullscreen');
      return;
    }

    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => {
        setIsFullscreen(true);
      }).catch(err => {
        console.error('Tam ekran hatası:', err);
      });
    } else {
      document.exitFullscreen().then(() => {
        setIsFullscreen(false);
      }).catch(err => {
        console.error('Tam ekrandan çıkış hatası:', err);
      });
    }
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    const handleElectronFullscreenChange = (e: any) => {
      setIsFullscreen(e.detail?.isFullScreen ?? false);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    window.addEventListener('electron-fullscreen-change', handleElectronFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      window.removeEventListener('electron-fullscreen-change', handleElectronFullscreenChange);
    };
  }, []);

  return { isFullscreen, toggleFullscreen };
};

export default useFullscreen;
